/* ============================================
   HEY.BUYER — Product Page JS
   ============================================ */

(function() {
  'use strict';

  console.log('[HB] custom-product.js loaded');

  /* ====== AJAX ADD TO CART ====== */
  function initProductAddToCart() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form || form.dataset.hbInit) return;
    form.dataset.hbInit = 'true';

    var btn = form.querySelector('.product-form__add-button.button.button--primary');
    if (!btn) return;

    var originalText = btn.textContent.trim() || 'Add to Cart';

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      // Guard: if the button is currently disabled (sold-out variant selected),
      // never let a fallback Enter-key / programmatic submit go through.
      if (btn.disabled || btn.classList.contains('button--disabled')) {
        return;
      }

      btn.classList.remove('ap-btn--success', 'ap-btn--error');
      btn.classList.add('ap-btn--loading');
      btn.textContent = 'Adding to cart...';

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Add failed');
        return res.json();
      })
      .then(function(data) {
        btn.classList.remove('ap-btn--loading');
        btn.textContent = originalText;
        showAddedMessage(form);
        updateCartCount();
        refreshCartSections();
      })
      .catch(function(err) {
        btn.classList.remove('ap-btn--loading');
        btn.classList.add('ap-btn--error');
        btn.textContent = 'Error - Try Again';
        setTimeout(function() {
          btn.classList.remove('ap-btn--error');
          btn.textContent = originalText;
        }, 2000);
      });
    });
  }

  function showAddedMessage(form) {
    var existing = document.querySelector('.hb-added-msg');
    if (existing) existing.remove();

    var msg = document.createElement('div');
    msg.className = 'hb-added-msg';
    msg.textContent = 'Product has been added to your cart';
    msg.style.cssText = 'background:#e3f4e3;color:#1a7a1a;padding:16px 18px;border-radius:14px;margin-top:14px;font-size:15px;font-weight:600;';

    var container = document.querySelector('.product-form__payment-container');
    if (container && container.parentNode) {
      container.parentNode.insertBefore(msg, container.nextSibling);
    } else {
      form.appendChild(msg);
    }

    setTimeout(function() { if (msg) msg.remove(); }, 4000);
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      var selectors = ['.cart-count', '.cart-count-bubble', '.header__cart-count',
        '[data-cart-count]', '.site-header__cart-count', '#CartCount'];
      selectors.forEach(function(sel) {
        document.querySelectorAll(sel).forEach(function(el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.classList.remove('hidden');
        });
      });
    });
  }

  function refreshCartSections() {
    fetch('/?sections=cart-icon-bubble,cart-drawer,cart-notification,header')
    .then(function(res) { return res.json(); })
    .then(function(sections) {
      Object.keys(sections).forEach(function(key) {
        var html = sections[key];
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newEl = doc.querySelector('[id^="shopify-section-' + key + '"]');
        var oldEl = document.querySelector('[id^="shopify-section-' + key + '"]');
        if (newEl && oldEl) oldEl.innerHTML = newEl.innerHTML;
      });
    }).catch(function() {});
  }

  /* ====== THUMBNAIL SCROLL ====== */
  function initThumbnailScroll() {
    var gallery = document.querySelector('.product-gallery');
    if (!gallery || gallery.dataset.hbScrollInit) return;
    gallery.dataset.hbScrollInit = 'true';

    var thumbList = gallery.querySelector('.product-gallery__thumbnail-list');
    if (!thumbList) return;

    var scrollBox = gallery.querySelector('.scroller__inner') || thumbList;

    var thumbs = thumbList.querySelectorAll('.product-gallery__thumbnail');
    if (!thumbs.length) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        setTimeout(function() {
          var boxRect = scrollBox.getBoundingClientRect();
          var thumbRect = thumb.getBoundingClientRect();
          var offset = (thumbRect.left - boxRect.left)
                     - (boxRect.width / 2)
                     + (thumbRect.width / 2);
          scrollBox.scrollBy({ left: offset, behavior: 'smooth' });
        }, 100);
      });
    });

    var targets = [
      gallery.querySelector('.scroller'),
      gallery.querySelector('.scroller__inner'),
      gallery.querySelector('.product-gallery__thumbnail-list')
    ].filter(Boolean);

    targets.forEach(function(el) {
      var startX = 0, startY = 0, locked = false;

      el.addEventListener('touchstart', function(e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        locked = false;
      }, { passive: true });

      el.addEventListener('touchmove', function(e) {
        if (e.touches.length !== 1) return;
        var dx = Math.abs(e.touches[0].clientX - startX);
        var dy = Math.abs(e.touches[0].clientY - startY);

        if (!locked && dx > dy && dx > 5) {
          locked = true;
        }

        if (locked) {
          e.preventDefault();
          e.stopPropagation();
          el.scrollLeft -= (e.touches[0].clientX - startX);
          startX = e.touches[0].clientX;
        }
      }, { passive: false });
    });
  }

  /* ====== SAVE BADGE WITH REAL PERCENTAGE ====== */
  function initSaveBadge() {
    var allBadges = document.querySelectorAll(
      '.hb-inline-save, .price__savings, .price-list__savings'
    );
    allBadges.forEach(function(el) { el.remove(); });

    document.querySelectorAll('.price-list span, .price-list a, .price-list div').forEach(function(el) {
      var txt = (el.textContent || '').trim();
      if (/^save(\s|$)/i.test(txt) && txt.length < 20) {
        if (el.children.length === 0) {
          el.remove();
        }
      }
    });

    var priceList = document.querySelector('.price-list');
    if (!priceList) return;

    var saleEl = priceList.querySelector('.price--highlight') ||
                 priceList.querySelector('.price:not(.price--compare)');
    var compareEl = priceList.querySelector('.price--compare');
    if (!saleEl || !compareEl) return;

    function toNum(el) {
      var txt = (el.textContent || '').replace(/[^\d.,]/g, '').replace(/,/g, '');
      return parseFloat(txt) || 0;
    }
    var sale = toNum(saleEl);
    var compare = toNum(compareEl);
    if (!compare || compare <= sale) return;

    var percent = Math.round(((compare - sale) / compare) * 100);
    if (percent <= 0) return;

    var badge = document.createElement('span');
    badge.className = 'hb-inline-save';
    badge.textContent = 'Save ' + percent + '%';

    if (compareEl.parentNode) {
      compareEl.parentNode.insertBefore(badge, compareEl.nextSibling);
    }
  }

  /* ====== INIT ====== */
  function init() {
    initProductAddToCart();
    initThumbnailScroll();
    initSaveBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setTimeout(init, 500);
  setTimeout(init, 1500);
  setTimeout(init, 3000);

  document.addEventListener('variant:change', function() {
    setTimeout(initSaveBadge, 200);
  });
  document.addEventListener('product:variant-change', function() {
    setTimeout(initSaveBadge, 200);
  });

})();

/* ============================================
   TRUST CONTENT — Timeline Animation & Badges
   ============================================ */

(function(){
  function initTrustTimeline(){
    var line = document.getElementById('hbLineFill');
    var s1 = document.getElementById('hbStep1');
    var s2 = document.getElementById('hbStep2');
    var s3 = document.getElementById('hbStep3');
    var badges = document.getElementById('hbBadges');
    if (!line || !s1 || !s2 || !s3) return;

    function placeBadges() {
      if (!badges) return false;
      var target = document.querySelector('.product-form__payment-container');
      if (!target) return false;
      if (badges.previousElementSibling === target) return true;
      target.parentNode.insertBefore(badges, target.nextSibling);
      return true;
    }

    placeBadges();
    var tries = 0;
    var iv = setInterval(function(){
      tries++;
      if (placeBadges() || tries > 30) clearInterval(iv);
    }, 200);

    var timers = [], running = false, visible = false;
    function clearTimers(){ timers.forEach(function(t){ clearTimeout(t); }); timers = []; }
    function add(fn, d){ timers.push(setTimeout(fn, d)); }
    function run(){
      line.style.transition = 'none'; line.style.width = '0%';
      s1.classList.remove('is-done'); s2.classList.remove('is-done'); s3.classList.remove('is-done');
      void line.offsetWidth;
      line.style.transition = 'width 1.2s cubic-bezier(0.65,0,0.35,1)';
      add(function(){ s1.classList.add('is-done'); }, 400);
      add(function(){ line.style.width = '50%'; }, 900);
      add(function(){ s2.classList.add('is-done'); }, 2100);
      add(function(){ line.style.width = '100%'; }, 2700);
      add(function(){ s3.classList.add('is-done'); }, 3900);
      add(function(){ if (visible) run(); else running = false; }, 6500);
    }
    function start(){ if (running) return; running = true; clearTimers(); run(); }
    function stop(){ running = false; clearTimers(); }
    var card2 = line.closest('.hb-premium-card');
    if (!card2) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        visible = e.isIntersecting;
        if (visible) start(); else stop();
      });
    }, { threshold: 0.3 });
    io.observe(card2);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrustTimeline);
  } else {
    initTrustTimeline();
  }
  setTimeout(initTrustTimeline, 500);
  setTimeout(initTrustTimeline, 1500);
})();

/* ===== HB ROW VARIANT: sync price + savings + CART ID + STOCK on selection ===== */
(function(){
  function money(cents){
    return '₹ ' + (cents/100).toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2});
  }

  function getVariants(){
    var el = document.getElementById('hb-variant-map');
    if(el){
      try {
        var parsed = JSON.parse(el.textContent);
        if(Array.isArray(parsed) && parsed.length) return parsed;
      } catch(e){
        console.warn('[HB] failed to parse hb-variant-map JSON', e);
      }
    }
    var d = document.querySelector('[data-product-json]');
    if(d){
      try {
        var j = JSON.parse(d.textContent);
        if(j && j.product && Array.isArray(j.product.variants)) return j.product.variants;
      } catch(e){}
    }
    return null;
  }

  // Returns selected values keyed by option position (1, 2, 3) instead of a flat array,
  // so matching is positional and not just "value exists somewhere among any option".
  function selectedValuesByPosition(){
    var byPos = {};
    document.querySelectorAll('.product-form__single-selector').forEach(function(el){
      var pos = el.getAttribute('data-option-position');
      if(!pos) return;

      if(el.tagName === 'SELECT'){
        if(el.name === 'id') return; // skip the hidden no-js variant select
        byPos[pos] = (el.value || '').trim();
      } else if(el.type === 'radio') {
        if(el.checked){
          byPos[pos] = (el.value || '').trim();
        }
      }
    });
    return byPos;
  }

  function matchVariant(variants){
    var sel = selectedValuesByPosition();
    var positions = Object.keys(sel);
    if(!positions.length) return null;

    var match = variants.filter(function(v){
      return positions.every(function(pos){
        var variantVal = v['option' + pos];
        return variantVal === sel[pos];
      });
    })[0];

    return match || null;
  }

  function setCartId(v){
    if(!v) return;
    var idField = document.querySelector('select[name="id"], input[name="id"]');
    if(!idField) return;
    if(String(idField.value) === String(v.id)) return;
    idField.value = v.id;
    idField.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function updatePrice(v){
    if(!v){
      console.warn('[HB] updatePrice called with no matched variant');
      return;
    }
    var box = document.querySelector('.product-form__info-content .price-list');
    if(!box){
      console.warn('[HB] .price-list container not found');
      return;
    }
    var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
    var html = '';
    if(hasCompare){
      html += '<span class="price price--highlight">' + money(v.price) + '</span>';
      html += '<span class="price price--compare">' + money(v.compare_at_price) + '</span>';
    } else {
      html += '<span class="price">' + money(v.price) + '</span>';
    }
    box.innerHTML = html;

    var info = box.parentElement;
    var save = info ? info.querySelector('.hb-save-badge') : null;
    if(hasCompare){
      var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
      if(!save){
        save = document.createElement('span');
        save.className = 'hb-save-badge';
        box.appendChild(save);
      }
      save.textContent = 'Save ' + pct + '%';
      save.style.display = '';
    } else if(save){
      save.style.display = 'none';
    }
  }

  // Recompute every visible row's own price/compare/unit/save display, AND
  // mark the row as sold-out if the variant it represents is unavailable.
  // Each row represents ONE value of its own option (e.g. "BUY 1 GET 1 FREE").
  // Its correct displayed price/availability depends on combining that row's
  // value with whatever is currently selected in the OTHER option groups.
  function updateAllRowPrices(variants){
    var sel = selectedValuesByPosition();

    document.querySelectorAll('.hb-row').forEach(function(rowWrap){
      var radio = rowWrap.querySelector('.hb-row__radio');
      if(!radio) return;
      var pos = radio.getAttribute('data-option-position');
      if(!pos) return;
      var rowValue = (radio.value || '').trim();

      // Build the selection this row would represent: current selections
      // for every OTHER position, plus this row's own value for its position.
      var trial = {};
      Object.keys(sel).forEach(function(p){ trial[p] = sel[p]; });
      trial[pos] = rowValue;

      var positions = Object.keys(trial);
      var match = variants.filter(function(v){
        return positions.every(function(p){ return v['option' + p] === trial[p]; });
      })[0];
      if(!match) return;

      var priceEl = rowWrap.querySelector('.hb-row__price');
      var compareEl = rowWrap.querySelector('.hb-row__rcompare');
      var priceLineEl = rowWrap.querySelector('.hb-row__priceline');
      var unitEl = rowWrap.querySelector('.hb-row__unit');
      var saveEl = rowWrap.querySelector('.hb-row__save');

      if(priceEl) priceEl.textContent = money(match.price);

      var hasCompare = match.compare_at_price && match.compare_at_price > match.price;
      if(hasCompare){
        if(compareEl){
          compareEl.textContent = money(match.compare_at_price);
          compareEl.style.display = '';
        } else if(priceLineEl){
          compareEl = document.createElement('span');
          compareEl.className = 'hb-row__rcompare';
          compareEl.textContent = money(match.compare_at_price);
          priceLineEl.appendChild(compareEl);
        }
      } else if(compareEl){
        compareEl.style.display = 'none';
      }

      if(saveEl && hasCompare){
        var pct = Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price);
        saveEl.textContent = 'Save ' + pct + '%';
      }

      if(unitEl){
        // Derive pack quantity from the row's own value text, mirroring the Liquid logic (first number found).
        var numMatch = rowValue.match(/\d+/);
        var qty = numMatch ? parseInt(numMatch[0], 10) : 1;
        if(qty > 1){
          unitEl.textContent = money(Math.round(match.price / qty)) + ' per unit';
          unitEl.style.display = '';
        } else {
          unitEl.style.display = 'none';
        }
      }
    });
  }

  // Enable/disable Add to Cart + Buy it now based on the CURRENTLY SELECTED
  // variant's availability. `v.available` already factors in "Sell when out
  // of stock": if that's ON, available stays true even at 0 quantity, so the
  // buttons are correctly left enabled in that case automatically.
  function updateButtonsState(v){
    var addBtn = document.querySelector('.product-form__add-button');
    var buyWrap = document.querySelector('.shopify-payment-button');
    if(!v || !addBtn) return;

    if(v.available){
      if(addBtn.dataset.hbOriginalText){
        addBtn.textContent = addBtn.dataset.hbOriginalText;
        delete addBtn.dataset.hbOriginalText;
      }
      addBtn.classList.remove('button--disabled');
      addBtn.classList.add('button--primary');
      addBtn.disabled = false;
      addBtn.removeAttribute('aria-disabled');
      if(buyWrap) buyWrap.style.display = '';
    } else {
      if(!addBtn.dataset.hbOriginalText){
        addBtn.dataset.hbOriginalText = addBtn.textContent.trim();
      }
      addBtn.classList.remove('button--primary');
      addBtn.classList.add('button--disabled');
      addBtn.disabled = true;
      addBtn.setAttribute('aria-disabled', 'true');
      addBtn.textContent = 'Sold Out';
      if(buyWrap) buyWrap.style.display = 'none';
    }
  }

  function syncAll(){
    var variants = getVariants();
    if(!variants){
      console.warn('[HB] no variant data available');
      return;
    }
    var v = matchVariant(variants);
    if(!v){
      console.warn('[HB] no matching variant for current selection', selectedValuesByPosition());
      return;
    }
    setCartId(v);
    updatePrice(v);
    updateAllRowPrices(variants);
    updateButtonsState(v);
  }

  function handleRadio(r){
    var val = (r.value || '').trim();
    var grp = r.closest('.product-form__option');
    var lbl = grp ? grp.querySelector('.product-form__selected-value') : null;
    if(lbl) lbl.textContent = val;
    r.checked = true;
    syncAll();
  }

  document.addEventListener('click', function(e){
    var label = e.target.closest('.hb-row__item, .block-swatch__item, .color-swatch__item, .variant-swatch__item');
    if(!label) return;
    var id = label.getAttribute('for');
    var r = id ? document.getElementById(id) : null;
    if(r){
      // let native label-click checking happen first, then sync
      requestAnimationFrame(function(){ handleRadio(r); });
    }
  });

  document.addEventListener('change', function(e){
    if(e.target.classList && e.target.classList.contains('product-form__single-selector')){
      handleRadio(e.target);
    }
  });

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(syncAll, 100); });
  } else {
    setTimeout(syncAll, 100);
  }
  setTimeout(syncAll, 800);
})();

/* ===== HB QUANTITY STEPPER (no price multiply) ===== */
(function(){
  function findInput(btn){
    var box = btn.closest('.quantity-selector');
    return box ? box.querySelector('input[name="quantity"], .quantity-selector__value') : null;
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-action="increase-picker-quantity"], [data-action="decrease-picker-quantity"]');
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var input = findInput(btn);
    if(!input) return;
    var val = parseInt(input.value, 10);
    if(isNaN(val) || val < 1) val = 1;
    if(btn.getAttribute('data-action') === 'increase-picker-quantity'){
      val = val + 1;
    } else {
      val = val - 1;
      if(val < 1) val = 1;
    }
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }, true);

  function clampQtyInput(input){
    var raw = (input.value || '').replace(/[^\d]/g, '');
    var n = parseInt(raw, 10);
    if(isNaN(n) || n < 1) n = 1;
    input.value = n;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('blur', function(e){
    if(e.target.matches('.quantity-selector input[name="quantity"], .quantity-selector__value')){
      clampQtyInput(e.target);
    }
  }, true);

  document.addEventListener('keydown', function(e){
    if(e.target.matches('.quantity-selector input[name="quantity"], .quantity-selector__value')){
      if(e.key === 'Enter'){
        e.preventDefault();
        clampQtyInput(e.target);
      }
    }
  });
})();

/* ===== HB VARIANT IMAGE SWAP — Symmetry/Flickity-aware ===== */
(function(){
  'use strict';

  var productData = null;
  var productHandle = null;

  function getProductHandle(){
    if(productHandle) return productHandle;
    var path = window.location.pathname;
    var match = path.match(/\/products\/([^\/\?#]+)/);
    if(match){ productHandle = match[1]; return productHandle; }
    return null;
  }

  function loadProductData(callback){
    if(productData){ callback(productData); return; }
    var handle = getProductHandle();
    if(!handle){ callback(null); return; }
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){
        if(d && d.variants){ productData = d; }
        callback(productData);
      })
      .catch(function(){ callback(null); });
  }

  // Keyed by option position, same approach as the price-sync block above,
  // so a multi-option product (e.g. Colour + Pack) resolves the correct variant
  // instead of matching any variant that merely contains the value somewhere.
  function getSelectedValuesByPosition(){
    var byPos = {};
    document.querySelectorAll('.product-form__single-selector').forEach(function(el){
      var pos = el.getAttribute('data-option-position');
      if(!pos) return;

      if(el.tagName === 'SELECT'){
        if(el.name === 'id') return;
        byPos[pos] = (el.value || '').trim();
      } else if(el.type === 'radio') {
        if(el.checked){
          byPos[pos] = (el.value || '').trim();
        }
      }
    });
    return byPos;
  }

  function findVariant(){
    if(!productData || !productData.variants) return null;
    var sel = getSelectedValuesByPosition();
    var positions = Object.keys(sel);
    if(!positions.length) return null;

    return productData.variants.filter(function(v){
      return positions.every(function(pos){
        return v['option' + pos] === sel[pos];
      });
    })[0] || null;
  }

  // SYMMETRY/FLICKITY: click the thumbnail anchor that matches this media id
  // This triggers Flickity to slide the main carousel to the corresponding slide.
  function swapImageByMediaId(mediaId){
    if(!mediaId) return false;
    var idStr = String(mediaId);

    // 1) Prefer thumbnail <a> elements — clicking them is what Symmetry expects
    var thumb = document.querySelector('a[data-media-id="' + idStr + '"]');
    if(thumb){
      thumb.click();
      return true;
    }

    // 2) Fallback: try any thumbnail-class element with that media id
    var thumbAlt = document.querySelector(
      '.product-gallery__thumbnail[data-media-id="' + idStr + '"], ' +
      '.product-gallery__thumb[data-media-id="' + idStr + '"]'
    );
    if(thumbAlt){
      thumbAlt.click();
      return true;
    }

    // 3) Last resort: find the main slide and use Flickity API directly
    var slides = document.querySelectorAll('.flickity-slider > [data-media-id], .flickity-slider [data-media-id]');
    if(slides.length){
      var targetIdx = -1;
      for(var i = 0; i < slides.length; i++){
        if(slides[i].getAttribute('data-media-id') === idStr){ targetIdx = i; break; }
      }
      if(targetIdx >= 0){
        var carousel = slides[0].closest('.flickity-enabled, [data-product-gallery], .product-gallery__carousel');
        if(carousel && window.Flickity){
          var flkty = window.Flickity.data(carousel);
          if(flkty){
            flkty.select(targetIdx);
            return true;
          }
        }
      }
    }
    return false;
  }

  function swapMainImage(){
    var v = findVariant();
    if(!v) return;
    var mediaId = (v.featured_media && v.featured_media.id) ? v.featured_media.id : null;
    if(!mediaId) return; // variant has no image — leave gallery as is
    swapImageByMediaId(mediaId);
  }

  function onSelectorChange(){
    setTimeout(function(){
      loadProductData(function(){ swapMainImage(); });
    }, 50);
  }

  document.addEventListener('change', function(e){
    if(e.target.classList && e.target.classList.contains('product-form__single-selector')){
      onSelectorChange();
    }
  });

  document.addEventListener('click', function(e){
    var label = e.target.closest('.hb-row__item, .block-swatch__item, .color-swatch__item, .variant-swatch__item');
    if(!label) return;
    setTimeout(onSelectorChange, 60);
  });

  function initialRun(){
    loadProductData(function(d){
      if(!d) return;
      swapMainImage();
    });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initialRun);
  } else {
    initialRun();
  }
  setTimeout(initialRun, 1200);

})();